export const displayUrl = (url) =>
  url?.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export const CATEGORIES = [
  { value: "portraits", label: "Portraits" },
  { value: "lifestyle", label: "Lifestyle" },
  { value: "featured", label: "Featured In" },
];
